import {Injectable} from '@angular/core';
import {DiagramConstants, DiagramLayers} from '../../../../utils/network-diagram/network-diagram-constants';
import * as _ from 'lodash';
import {OfflineNetworkLayersService} from '../offline-network-layers-service/offline-network-layers.service';
import {OfflineDiagramMappersUtilsService} from '../offline-diagram-mappers-utils/offline-diagram-mappers-utils.service';
import {MetaDataService} from '../../../../services/metaData/meta-data.service';
import {Status} from '../../../../services/enums/status.enum';

@Injectable({
  providedIn: 'root'
})
export class DataItemToVisualsMappersOfflineService {

  constructor(private offlineNetworkLayersService: OfflineNetworkLayersService,
              private offlineDiagramMappersUtilsService: OfflineDiagramMappersUtilsService,
              private metaDataService: MetaDataService) {
  }

  connectionStateToColorWidthAndPriorityObject = {
    UNKNOWN: {color: DiagramConstants.COLORS.blue, width: DiagramConstants.CONNECTION_WIDTH_TYPES.regular, priority: 1},
    GOOD: {color: DiagramConstants.COLORS.blue, width: DiagramConstants.CONNECTION_WIDTH_TYPES.regular, priority: 2},
    MEDIUM: {color: DiagramConstants.COLORS.orange, width: DiagramConstants.CONNECTION_WIDTH_TYPES.thick, priority: 3},
    BAD: {color: DiagramConstants.COLORS.red, width: DiagramConstants.CONNECTION_WIDTH_TYPES.thick, priority: 4}
  };

  peerConnectionStateToColorWidthAndPriorityObject = {
    UNKNOWN: {color: DiagramConstants.COLORS.grey, width: DiagramConstants.CONNECTION_WIDTH_TYPES.regular, priority: 1},
    GOOD: {color: DiagramConstants.COLORS.grey, width: DiagramConstants.CONNECTION_WIDTH_TYPES.regular, priority: 2},
    MEDIUM: {color: DiagramConstants.COLORS.orange, width: DiagramConstants.CONNECTION_WIDTH_TYPES.thick, priority: 3},
    BAD: {color: DiagramConstants.COLORS.red, width: DiagramConstants.CONNECTION_WIDTH_TYPES.thick, priority: 4}
  };
  operStateToColor = {
    15: DiagramConstants.COLORS.blue,
    14: DiagramConstants.COLORS.red,
    13: DiagramConstants.COLORS.red,
    12: DiagramConstants.COLORS.red,
    11: DiagramConstants.COLORS.red,
    10: DiagramConstants.COLORS.red,
    9: DiagramConstants.COLORS.red,
    8: DiagramConstants.COLORS.red,
    7: DiagramConstants.COLORS.red,
    6: DiagramConstants.COLORS.red,
    5: DiagramConstants.COLORS.red,
    4: DiagramConstants.COLORS.red,
    3: DiagramConstants.COLORS.red,
    2: DiagramConstants.COLORS.red,
    1: DiagramConstants.COLORS.red,
    0: DiagramConstants.COLORS.red,

    92: DiagramConstants.COLORS.red,
    93: DiagramConstants.COLORS.orange,
    94: DiagramConstants.COLORS.orange
  };

  operStateToBorderColor = {
    15: DiagramConstants.COLORS.darkBlue,
    14: DiagramConstants.COLORS.darkRed,
    13: DiagramConstants.COLORS.darkRed,
    12: DiagramConstants.COLORS.darkRed,
    11: DiagramConstants.COLORS.darkRed,
    10: DiagramConstants.COLORS.darkRed,
    9: DiagramConstants.COLORS.darkRed,
    8: DiagramConstants.COLORS.darkRed,
    7: DiagramConstants.COLORS.darkRed,
    6: DiagramConstants.COLORS.darkRed,
    5: DiagramConstants.COLORS.darkRed,
    4: DiagramConstants.COLORS.darkRed,
    3: DiagramConstants.COLORS.darkRed,
    2: DiagramConstants.COLORS.darkRed,
    1: DiagramConstants.COLORS.darkRed,
    0: DiagramConstants.COLORS.darkRed,

    92: DiagramConstants.COLORS.darkRed,
    93: DiagramConstants.COLORS.darkOrange,
    94: DiagramConstants.COLORS.darkOrange
  };

  labelOptions: any = {};

  private static convertHex(hex, opacity): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  }

  setLabelOptions(options): void {
    this.labelOptions = _.cloneDeep(options);
  }
  getLabelOptions(): void {
    return this.labelOptions;
  }
  getClusteredNodeProperties(nodesInCluster): any {
    function getBorderColor(nodeCluster): any {
      const filteredNodes = nodeCluster.filter((childNode) => {
        return isFiltered(childNode.dataItem);
      });

      if (filteredNodes.length > 0) {
        return DiagramConstants.COLORS.darkGrey;
      } else {
        DataItemToVisualsMappersOfflineService.convertHex(DiagramConstants.COLORS.darkGrey, 30);
      }
    }

    function getColor(nodeCluster): any {
      const filteredNodes = nodeCluster.filter((childNode) => {
        return isFiltered(childNode.dataItem);
      });

      if (filteredNodes.length > 0) {
        return DiagramConstants.COLORS.grey;
      } else {
        return DataItemToVisualsMappersOfflineService.convertHex(DiagramConstants.COLORS.grey, 30);
      }
    }

    function getClusteredNodeImage(): string {
      return 'assets/images/network/elements/voippeers/aggregation.svg';
    }

    function getClusteredNodeTooltip(clusterNodes): string {
      return clusterNodes.length + ' voip peers';
    }

    function isFiltered(dataItem): any {
      return (dataItem.hasOwnProperty('filtered') && dataItem.filtered) || !dataItem.hasOwnProperty('filtered');
    }

    return {
      title: getClusteredNodeTooltip(nodesInCluster),
      image: getClusteredNodeImage(),
      color: {border: getBorderColor(nodesInCluster), background: getColor(nodesInCluster)}
    };

  }

  getClusteredEdgeProperties(edgesInCluster): any {
    const getDashType = (baseEdges) => {
      const selectedLayers = this.offlineNetworkLayersService.getSelectedLayers();

      if (selectedLayers.quality && !selectedLayers.topology) {
        const unknownQualityEdge = baseEdges.find((baseEdge) => {
          return baseEdge.dashes === DiagramConstants.DASH_TYPES.dash;
        });

        if (unknownQualityEdge) {
          return DiagramConstants.DASH_TYPES.dash;
        }
      }

      return DiagramConstants.DASH_TYPES.solid;
    };

    function getClusteredEdgeColor(baseEdges): any {
      let clusterColor = DiagramConstants.COLORS.grey;

      baseEdges.some((baseEdge) => {
        if ((clusterColor === DiagramConstants.COLORS.orange || clusterColor === DiagramConstants.COLORS.grey) && baseEdge.color.color ===
          DiagramConstants.COLORS.red) {
          clusterColor = DiagramConstants.COLORS.red;
        } else if (clusterColor === DiagramConstants.COLORS.grey && baseEdge.color.color === DiagramConstants.COLORS.orange) {
          clusterColor = DiagramConstants.COLORS.orange;
        }
        return clusterColor === DiagramConstants.COLORS.red;
      });

      return clusterColor;
    }

    function getWidth(baseEdges): number {
      const filteredEdges = baseEdges.filter((baseEdge) => {
        return isFilteredForWidth(baseEdge.dataItem);
      });

      return filteredEdges.length > 0 ? DiagramConstants.CONNECTION_WIDTH_TYPES.extraThick : DiagramConstants.CONNECTION_WIDTH_TYPES.thick;
    }

    function numberOfClusterEdges(numberOfEdges: number): any {
      return numberOfEdges >= 99 ? '99+' : numberOfEdges;
    }

    function getClusteredEdgeOpacity(baseEdges): number {
      const filteredEdges = baseEdges.filter((baseEdge) => {
        return isFiltered(baseEdge.dataItem);
      });

      return filteredEdges.length > 0 ? 1 : 0.3;
    }

    function getClusteredEdgeTooltip(clusterEdges): string {
      return numberOfClusterEdges(clusterEdges.length) + ' peer connections';
    }

    function isFilteredForWidth(dataItem): boolean {
      return (dataItem.hasOwnProperty('filtered') && dataItem.filtered);
    }

    function isFiltered(dataItem): boolean {
      return (dataItem.hasOwnProperty('filtered') && dataItem.filtered) || !dataItem.hasOwnProperty('filtered');
    }

    return {
      color: getClusteredEdgeColor(edgesInCluster),
      opacity: getClusteredEdgeOpacity(edgesInCluster),
      title: getClusteredEdgeTooltip(edgesInCluster),
      width: getWidth(edgesInCluster),
      dashes: getDashType(edgesInCluster)
    };

  }

  prepareClustersPropertiesForDiagram = (clusters) => {
    if (!_.isNil(clusters)) {
      clusters.forEach(cluster => cluster.label = this.prepareLabelForDiagram(cluster.name));
    }
    return clusters;
  }

  prepareLabelForDiagram(name: string): string {
    return (this.labelOptions.shorten && (name.length > this.labelOptions.length)) ?
        (name.substring(0, this.labelOptions.length) + '...') : name;
  }

  prepareConnectionPropertiesForDiagram(edge): any {

    const getDashType = (dataItem) => {
      if (dataItem) {
        const selectedLayers = this.offlineNetworkLayersService.getSelectedLayers();

        if (selectedLayers.quality && !selectedLayers.topology) {
          if (dataItem.result === 'UNKNOWN') {
            return DiagramConstants.DASH_TYPES.dash;
          }
        }
      }
      return DiagramConstants.DASH_TYPES.solid;
    };

    const getWidth = (dataItem, connectionType) => {
      if (isFilteredForWidth(dataItem)) {
        return DiagramConstants.CONNECTION_WIDTH_TYPES.extraThick;
      }
      if (connectionType === 'connection') {
        return this.connectionStateToColorWidthAndPriorityObject[getStatus(dataItem, 'connection')].width;
      } else {
        return this.peerConnectionStateToColorWidthAndPriorityObject[getStatus(dataItem, 'pCon')].width;
      }
    };

    function getStatusColor(dataItem, connectionType): any {
      if (dataItem && dataItem.id !== '') {
        return calculateSingleItemColor(dataItem, connectionType);
      } else {
        return DiagramConstants.COLORS.black;
      }
    }

    function getOpacity(dataItem): number {
      return isFiltered(dataItem) ? 1.0 : 0.3;
    }

    const calculateSingleItemColor = (dataItem, connectionType): any => {
      if (connectionType === 'connection') {
        return this.connectionStateToColorWidthAndPriorityObject[getStatus(dataItem, 'connection')].color;
      } else {
        return this.peerConnectionStateToColorWidthAndPriorityObject[getStatus(dataItem, 'pCon')].color;
      }
    };

    const getStatus = (dataItem, type): any => {
      const selectedLayers = this.offlineNetworkLayersService.getSelectedLayers();
      let result = Status.UNKNOWN;
      let status;

      DiagramLayers.forEach((layerName) => {
        if (selectedLayers[layerName]) {
          if (type === 'connection') {
            status = this.offlineDiagramMappersUtilsService.connectionStatusByLayer(dataItem, layerName);
            result = statusToUpdateConnectionWith(status, result);
          } else {
            status = this.offlineDiagramMappersUtilsService.peerConnectionStatusByLayer(dataItem, layerName);
            result = statusToUpdatePeerConnectionWith(status, result);
          }
        }
      });
      return result;
    };

    const statusToUpdateConnectionWith = (currentStatus, oldStatus) => {
      if (this.connectionStateToColorWidthAndPriorityObject[currentStatus].priority >
        this.connectionStateToColorWidthAndPriorityObject[oldStatus].priority) {
        return currentStatus;
      } else {
        return oldStatus;
      }
    };

    const statusToUpdatePeerConnectionWith = (currentStatus, oldStatus) => {
      if (this.peerConnectionStateToColorWidthAndPriorityObject[currentStatus].priority >
        this.peerConnectionStateToColorWidthAndPriorityObject[oldStatus].priority) {
        return currentStatus;
      } else {
        return oldStatus;
      }
    };

    function isFilteredForWidth(dataItem): any {
      return (dataItem.hasOwnProperty('filtered') && dataItem.filtered);
    }

    function isFiltered(dataItem): any {
      return (dataItem.hasOwnProperty('filtered') && dataItem.filtered) || !dataItem.hasOwnProperty('filtered');
    }

    function isLocked(dataItem, connectionType): boolean {
      if (connectionType === 'peerConnection') {
        return dataItem.adminState === 'LOCKED';
      } else {
        return false;
      }
    }

    function getTooltipContent(edgeOfTooltip): string {
      let operState;
      if (edgeOfTooltip.connectionType === 'connection') {
        if (edgeOfTooltip.dataItem.type === 'REGULAR') {
          operState = edgeOfTooltip.dataItem.connections[0].operState === 'UNAVAILABLE'
          || edgeOfTooltip.dataItem.connections[1].operState === 'UNAVAILABLE' ?
            'UNAVAILABLE' : 'AVAILABLE';
          return 'Name: ' + edgeOfTooltip.dataItem.name + '\n' +
            'State: ' + operState;
        } else {
          operState = edgeOfTooltip.dataItem.connections[0].operState === 'UNAVAILABLE' ? 'UNAVAILABLE' : 'AVAILABLE';
          return 'Name: ' + edgeOfTooltip.dataItem.name + '\n' +
            'State: ' + operState;
        }
      } else {
        return 'Name: ' + edgeOfTooltip.dataItem.name + '\n' +
          'State: ' + edgeOfTooltip.dataItem.operState;
      }
    }

    if (edge.connectionType === 'connection') {
      edge.from = 'node_' + edge.dataItem.connections[0].srcNodeId;
      edge.to = 'node_' + edge.dataItem.connections[0].destNodeId;
    } else {
      edge.from = 'node_' + edge.dataItem.nodeId;
      edge.to = 'voippeer_' + edge.dataItem.voipPeerId;
    }

    edge.color = {color: getStatusColor(edge.dataItem, edge.connectionType), opacity: getOpacity(edge.dataItem)};
    edge.label = this.generateLockLabel(edge.dataItem, edge.connectionType);
    edge.title = getTooltipContent(edge);
    edge.width = getWidth(edge.dataItem, edge.connectionType);
    edge.dashes = getDashType(edge.dataItem);

    return edge;
  }
  prepareShapePropertiesForDiagram(shape): string {

    const getStatusColor = (dataItem, shapeType): string => {
      if (shapeType === 'node') {
        const statusColor = this.operStateToColor[dataItem.operState.state];
        return statusColor ? statusColor : DiagramConstants.COLORS.blue;
      } else {
        return DiagramConstants.COLORS.grey;
      }
    };

    const getBorderColor = (dataItem, shapeType): string => {
      if (shapeType === 'node') {
        const statusColor = this.operStateToBorderColor[dataItem.operState.state];
        return statusColor ? statusColor : DiagramConstants.COLORS.darkBlue;
      } else {
        return DiagramConstants.COLORS.darkGrey;
      }
    };

    const getLabelText = (dataItem) => {
      if (this.labelOptions.shorten === true) {
        return dataItem.name.length > this.labelOptions.length ? dataItem.name.substring(0, this.labelOptions.length) + '...' :
          dataItem.name;
      }
      return dataItem.name;
    };

    function getShapeType(dataItem, shapeType): string {
      if (shapeType === 'node') {
        if (dataItem.productType !== 'GW' &&
            !(dataItem.productType === 'HYBRID' && dataItem.teamsRole === 'PROXY') &&
            (dataItem.teamsRole === 'REMOTE' || dataItem.teamsRole === 'PROXY')) {
          return `${dataItem.productType}_TEAMS_${dataItem.teamsRole}`;
        }
        return dataItem.productType;
      } else {
        return dataItem.deviceType;
      }
    }

    function isLocked(dataItem, shapeType): boolean {
      if (shapeType === 'node') {
        return dataItem.adminState === 'LOCKED';
      } else {
        return false;
      }
    }

    function getTooltipContent(shapeOfTooltip): string {
      if (shapeOfTooltip.shapeType === 'node') {
        if (shapeOfTooltip.dataItem.productType === 'THIRD_PARTY') {
          return 'Name: ' + shapeOfTooltip.dataItem.name + '\n' +
            'State: ' + shapeOfTooltip.dataItem.operState.description;
        } else {
          return 'Name: ' + shapeOfTooltip.dataItem.name + '\n' +
            'Address: ' + (shapeOfTooltip.dataItem.addressForGUI !== null ? shapeOfTooltip.dataItem.addressForGUI : '') + '\n' +
            'State: ' + shapeOfTooltip.dataItem.operState.description;
        }
      } else {
        return 'Name: ' + shapeOfTooltip.dataItem.name + '\n' +
          'Type: ' + shapeOfTooltip.dataItem.deviceType;
      }
    }

    function isFiltered(dataItem): any {
      return (dataItem.hasOwnProperty('filtered') && dataItem.filtered) || !dataItem.hasOwnProperty('filtered');
    }

    shape.color = {};
    shape.color.border = getBorderColor(shape.dataItem, shape.shapeType);
    shape.color.background = getStatusColor(shape.dataItem, shape.shapeType);
    shape.label = getLabelText(shape.dataItem);
    shape.title = getTooltipContent(shape);
    shape.x = shape.dataItem.x;
    shape.y = shape.dataItem.y;

    if (shape.shapeType === 'node') {
      shape.image = 'assets/images/network/elements/nodes/' + getShapeType(shape.dataItem, shape.shapeType) +
        (isLocked(shape.dataItem, shape.shapeType) ? '_lock' : '') + '.svg';
    } else {
      shape.image = 'assets/images/network/elements/voippeers/' + getShapeType(shape.dataItem, shape.shapeType) + '.svg';
    }

    if (!isFiltered(shape.dataItem)) {
      shape.color.background = DataItemToVisualsMappersOfflineService.convertHex(shape.color.background, 30);
      shape.color.border = DataItemToVisualsMappersOfflineService.convertHex(shape.color.border, 30);
    }

    return shape;
  }
  private generateLockLabel(dataItem, connectionType): string {
    if (connectionType === 'peerConnection' && dataItem.adminState !== 'UNLOCKED') {
      return `[${this.metaDataService.PeerConnectionAdminStatus[dataItem.adminState].label}]`;
    }

    return ' ';
  }
}
